import { isArray } from 'lodash'
export const calcColumnStyle = (
  column,
  fixedColumn,
  fixed
) => {
  const flex = {
    flexGrow: 0,
    flexShrink: 0,
    ...(fixed
      ? {}
      : {
          flexGrow: column.flexGrow || 0,
          flexShrink: column.flexShrink || 1,
        }),
  }

  if (!fixed) {
    flex.flexShrink = 1
  }

  const style = {
    ...(column.style ? column.style : {}),
    ...flex,
    flexBasis: 'auto',
    width: column.width,
  }

  if (!fixedColumn) {
    if (column.maxWidth) style.maxWidth = column.maxWidth
    if (column.minWidth) style.minWidth = column.minWidth
  }

  return style
}

const sumReducer = (sum, num) => sum + num
export const sum = (listLike) => {
  return isArray(listLike) ? listLike.reduce(sumReducer, 0) : listLike
}

export const getColumnsVisible = (columns) => columns.filter(i => !(i.children && i.children.length))


const rowKeyStrategyFunctions = {
  function: (row, rowKey) => (rowKey(row)),
  string: (row, rowKey) => (row[rowKey]),
}

export const getRowKeyIter = function(row, rowKey) {
  const type = typeof rowKey
  const strategyFunction = rowKeyStrategyFunctions[type] || rowKeyStrategyFunctions.string
  return strategyFunction(row, rowKey)
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/config/utils.js